module.exports = __webpack_public_path__ + "img/small-2.a459b324.webp";